import React, { Component } from "react";
import { CustomTextField } from "./TextField";
import { validators, validate } from "../../helpers/validationHelpers";

class Mobile extends Component {
  static defaultProps = {
    value: "",
    errorText: undefined,
    onChange: () => {},
    onBlur: () => {}
  };

  constructor(props) {
    super(props);
    this.state = {
      isValid: false
    };
  }

  validate = (value, setState = false) => {
    const { fieldKey, onError } = this.props;
    const errorMessage = validate(validators[fieldKey], value);

    if (errorMessage !== this.props.errorText || setState) {
      onError(fieldKey, errorMessage);
      if (errorMessage === "") {
        if (!this.state.isValid) this.setState({ isValid: true });
      } else {
        if (this.state.isValid) this.setState({ isValid: false });
      }
    }
  };

  handleBlur = () => {
    this.validate(this.props.value, true);
  };

  handleChange = e => {
    const value = e.target.value;
    const reg = /^\d+$/;
    if (!reg.test(value) && value !== "") {
      return;
    }

    if (value.length === 0 || value.length > 10) {
      this.validate(value);
    } else {
      this.props.onError(this.props.fieldKey, "");
    }
    this.props.onChange(this.props.fieldKey, value);
  };

  render() {
    return (
      <span>
        <CustomTextField
          floatingLabelText="Your mobile number"
          value={this.props.value}
          errorText={this.props.errorText}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          isValid={this.state.isValid}
        />
        <span
          style={{ fontSize: "13px", fontWeight: 300, fontStyle: "italic" }}
        >
          {this.props.mobileHintDescription}
        </span>
      </span>
    );
  }
}

export { Mobile };



// WEBPACK FOOTER //
// ./src/modules/ContactForm/components/FormFields/Mobile.js